import { NavbarLink } from './navbar.types'

const USDC_ADDRESS = '0x28a92dde19D9989F39A49905d7C9C2FAc7799bDf'

export const SPOOKY_SWAP_LINK = 'https://v2.spooky.fi/#/bridge'
export const SPOOKY_USDC_LINK =
    'https://spooky.fi/#/best-swap?outputCurrency=' + USDC_ADDRESS

export const UNISWAP_WPOKT_LINK = 'https://app.uniswap.org/explore/tokens/ethereum/0x67f4c72a50f8df6487720261e188f2abe83f57d7'

export const FTM_EXPLORER_USDC = 'https://ftmscan.com/token/' + USDC_ADDRESS +'?a='

export const ETH_EXPLORER_WPOKT = 'https://etherscan.io/token/0x67f4c72a50f8df6487720261e188f2abe83f57d7?a='

export const FTM_EXPLORER_LINK = (): string => {
    if (process.env.NODE_ENV === 'production') {
        return `https://ftmscan.com/address/`
    }
    return `https://testnet.snowtrace.io/address/`
}

export const ETH_EXPLORER_LINK = 'https://etherscan.io/address/'

export const NAVIGATION_LINKS: NavbarLink[] = [
  { url: '/management', name: 'Management History', icon: 'history' },
]

export const supportedChains = ["FTM", "ETH"]
